import useSWR, { SWRResponse } from 'swr';
import type { AxiosError } from 'axios';
import { Task } from '../../../providers/api/dtos';
import { getTask } from '../../../providers/api/task/taskProvider';
import { API_TASKS_PATH } from '../../../providers/api/api';

export default function useTask(taskId?: Task['id']): SWRResponse<Task, AxiosError> {
  return useSWR(taskId ? [API_TASKS_PATH, taskId] : null, () => getTask(taskId!));
}
